import HTTP_REQUEST from "../../utils/http";
import url from "../../utils/url";
import Cookies from 'js-cookie';
import {
  API_CANAL,
  API_SEGURIDAD,
  dataLead,
  StateMachine,
} from "../../utils/consts";
import * as vidaTypes from "../types/vida";
import { changeGlobalState, changeErrorData, changeIndValidacion } from "./global";
import {
  ERROR_CODE_LEAD,
  ERROR_CODE_NOT_FOUND
} from "../../utils/consts";
import helpers from "../../utils/helpers";
import { decryptAES, encryptAES } from "../../utils/CryptographyUtils";
import { securityDecode } from "../../utils/awsConfig";
import {
  LIMIT_YOUNGER_AGE,
  LIMIT_OLDER_AGE_PLUS,
  LIMIT_OLDER_AGE,
  IDE_TERCERO,
  BDU_ORIGIN,
  AX_ORIGIN,
  TERCERO_ERROR
} from "../../utils/consts";
import { selectDomicilio } from "./domcilio";
import { getCodeSecurity } from "../../utils/apiCanal";
import { decryptCredentials } from "../../utils/cifrate";

export const getPersonData = (data) => ({
  type: vidaTypes.GET_PERSON,
  data,
});

export const saveStep = (data) => ({
  type: vidaTypes.SAVE_STEP,
  data,
});

export const getPersonDataFilled = (data) => ({
  type: vidaTypes.GET_PERSON_DATA,
  data,
});

export const getPersonSuccess = () => ({
  type: vidaTypes.GET_PERSON_SUCCESS,
});

export const sendLead = (data) => ({
  type: vidaTypes.SEND_LEAD,
  data,
});

const getCodesecurity = () => {
  return securityDecode[0].password;
};

export const resetState = () => ({
  type: vidaTypes.INIT_STATE,
});

export const cleanPerson = () => ({
  type: vidaTypes.CLEAN_PERSON,
});

export const initSettingData = (data) => ({
  type: vidaTypes.INIT_SETTING_DATA,
  data,
});

export const saveUSerData = (data) => ({
  type: vidaTypes.SAVE_USER_DATA,
  data,
});

export const setIsNewClient = (data) => ({
  type: vidaTypes.IS_NEW_CLIENT,
  data,
});

export const setExperimentStepData = (data) => ({
  type: vidaTypes.EXPERIMENT_STEP_DATA,
  data,
});

export const setExperimentStepPayment = (data) => ({
  type: vidaTypes.EXPERIMENT_STEP_PAYMENT,
  data,
});

export const setAdviserConfig = (data) => ({
  type: vidaTypes.SET_ADVISER_CONFIG,
  data,
});

export const setExperimentQuote = (data) => ({
  type: vidaTypes.SET_EXPERIMENT_QUOTE,
  data
});

export const getPersonAsync = (data, cb) => async (dispatch) => {
  const locationPathname = window.location.pathname;
  const isVidaplus = locationPathname.includes("vida-plus");
  data.canal = "vcd";
  const minAge = LIMIT_YOUNGER_AGE;
  const maxAge = isVidaplus ? LIMIT_OLDER_AGE_PLUS : LIMIT_OLDER_AGE;
  const producto = helpers.validateVidaPlus() ? 'Seguro Vida Plus' : helpers.validateViajes() ? 'Seguro Viajes' : 'Seguro Vida Devolución Garantizada';
  try {
    dispatch(cleanPerson());
    const apiUrl = url.newObtenerTercero;
    const respTerceros = await HTTP_REQUEST.postWitchTrace(
      apiUrl,
      data,
      "APIS_VCT",
      API_CANAL
    );

    const {
      payload: payloadTerceros,
      status: statusTerceros,
    } = respTerceros.response;
    let terceroJSON = JSON.parse(
      decryptAES(payloadTerceros, getCodesecurity())
    );
    window.originTJSON = terceroJSON?.origen;
    if (statusTerceros.success) {
      helpers.getTrackBDU(
        `Origen validación Cliente - ${producto}`,
        terceroJSON?.origen,
        {
          typeDoc: data.tipoDocumento,
          numDoc: data.numeroDocumento
        }
      );
      if(terceroJSON.origen === BDU_ORIGIN || terceroJSON.origen === AX_ORIGIN) {
        const edad = helpers.calcularEdad(terceroJSON.fechaNacimiento);
        if (edad > maxAge || edad < minAge) {
          dispatch(changeGlobalState(6));
        } else {
          if (!data.withoutUbigeo) {
            const { departamento, provincia, distrito, nombreVia, tipoVia, numeroVia } = helpers.getClientUbigeo(terceroJSON);
            if (departamento) {
              const payloadDomicilio = {
                validUbigeo: true,
                departamento,
                provincia,
                distrito,
                nombreVia: nombreVia || '',
                ...(tipoVia.text && { tipoVia }),
                ...(numeroVia && { numeroVia }),
              };
              dispatch(selectDomicilio(payloadDomicilio));
            }
          }
          dispatch(changeGlobalState(0));
        }
        cb && cb(terceroJSON);
        dispatch(getPersonData(terceroJSON));
        dispatch(getPersonSuccess());
      } else {
        cb && cb(terceroJSON);
        dispatch(changeGlobalState(9));
        dispatch(getPersonSuccess());
        return;
      }
    }
    return statusTerceros.success;
  } catch (error) {
    if (error.response !== undefined) {
      const errorCode = error.response.data?.response?.status?.error?.code;
      if (errorCode === TERCERO_ERROR.RENIEC_ERROR && data.tipoDocumento === '4') {
        dispatch(changeGlobalState(9));
        dispatch(getPersonSuccess());
        return;
      }
      if (errorCode === TERCERO_ERROR.INVALID_ERROR || errorCode === TERCERO_ERROR.RENIEC_ERROR) {
        helpers.getTrackBDU(
          `Origen validación Cliente - ${producto}`,
          'NE',
          {
            typeDoc: data.tipoDocumento,
            numDoc: data.numeroDocumento
          }
        );
        !data.isChildren && dispatch(changeGlobalState(14));
        dispatch(getPersonSuccess());
        dispatch(
          changeErrorData({
            error: error,
            code: ERROR_CODE_NOT_FOUND,
            message: error.message,
          })
        );
        helpers.getTagError(ERROR_CODE_NOT_FOUND, error.message, "trackError");
        helpers.getTagMetadata("Endpoint", url.obtenerTercero, "trackMetadata");
      } else {
        dispatch(changeGlobalState(4));
        helpers.sendTagError(error, url.obtenerTercero);
      }
    } else {
      dispatch(changeGlobalState(4));
      helpers.sendTagError(error, url.obtenerTercero);
    }
  }
};

export const validatePersonData =  (request) => async (dispatch) => {
  try {
    request.canal = "vcd";
    const { response } = await HTTP_REQUEST.postWitchTrace(
      url.validarTercero,
      request,
      "APIS_VCT",
      API_CANAL
    );
    const { payload, status } = response;
    let payloadJSON = JSON.parse(
      decryptAES(payload, getCodesecurity())
    );
    if(status.success) {
      const { resultinterpretacion, resultvalidacion: { resultinputref, resultinputper } } = payloadJSON;
      return { resultinterpretacion, resultinputref, resultinputper };
    } else {
      dispatch(changeGlobalState(14));
    }
  } catch (error) {
    dispatch(changeGlobalState(14));
    helpers.sendTagError(error, url.validarTercero);
  }
};

export const getValidationsRules = (data) => async (dispatch) => {
  try {
    const respValidacion = await HTTP_REQUEST.postWitchTrace(
      url.validationPoliza,
      { ...data, ideTercero: IDE_TERCERO },
      "APIS_VCT",
      API_CANAL
    );

    const { payload, status } = respValidacion.response;

    if (status.success) {
      const { indValidado, reglas = [] } = payload;

      dispatch(changeGlobalState(0));
      if (!indValidado) {
        const [blackList, yellowList, yellowListPEP, nroPolizas, cumulos] = reglas;
        if (data.onlyBL) {
          if (blackList && !blackList.valor) {
            dispatch(changeGlobalState(13));
            helpers.getTagError("code", StateMachine[13], "trackError");
            helpers.getTagMetadata(
              "Endpoint",
              url.validationPoliza,
              "trackMetadata"
            );
          }
          return;
        }
        if (blackList && !blackList.valor) {          
          helpers.getTagError("code", StateMachine[13], "trackError");
          helpers.getTagMetadata(
            "Endpoint",
            url.validationPoliza,
            "trackMetadata"
          );
        }
        if (nroPolizas && !nroPolizas.valor) {
          helpers.getTagError("code", StateMachine[10], "trackError");
          helpers.getTagMetadata(
            "Endpoint",
            url.validationPoliza,
            "trackMetadata"
          );
        }
        if ((yellowList && !yellowList.valor) || (yellowListPEP && !yellowListPEP.valor)) {
          helpers.getTagError("code", StateMachine[11], "trackError");
          helpers.getTagMetadata(
            "Endpoint",
            url.validationPoliza,
            "trackMetadata"
          );
        }
        if (cumulos && !cumulos.valor) {
          helpers.getTagError("code", StateMachine[12], "trackError");
          helpers.getTagMetadata(
            "Endpoint",
            url.validationPoliza,
            "trackMetadata"
          );
        }

        const validationData = {
          indPoliza: helpers.validateVidaPlus() ? (nroPolizas && !nroPolizas.valor) : false,
          indYellowList: (yellowList && !yellowList.valor) || (yellowListPEP && !yellowListPEP.valor),
          indCumulos: cumulos && !cumulos.valor,
          indBlackList: blackList && !blackList.valor,
        }
        dispatch(changeIndValidacion(validationData));
      }
      dispatch(getPersonDataFilled(indValidado));
      dispatch(getPersonSuccess());
    } else {
      dispatch(changeGlobalState(9));
      dispatch(getPersonSuccess());
    }
    return status.success;
  } catch (error) {
    dispatch(changeGlobalState(4));
    helpers.sendTagError(error, url.validationPoliza);
  }
};

export const registrarLead = (dataIn) => async (dispatch) => {
  let data = { ...dataIn, ...dataLead };
  try {
    for (let key in data) {
      if (data.hasOwnProperty(key)) {
        if (data[key] === null || data[key] === "") {
          delete data[key];
        }
      }
    }

    if (data) {
      const upperCase = (str) => (str||'').toUpperCase();

      let origenDatos = false;
      if (data.nombres) {
        if (data.apellidoPaterno) {
          if (!upperCase(data.nombres).includes(upperCase(data.apellidoPaterno))) {
            data.nombres = data.nombres + ' ' + data.apellidoPaterno;
          }
          delete data.apellidoPaterno;
        } 
        if (data.apellidoMaterno) {
          if (!upperCase(data.nombres).includes(upperCase(data.apellidoMaterno))) {
            data.nombres = data.nombres + ' ' + data.apellidoMaterno;
          }
          delete data.apellidoMaterno;
        }
        data.nombres = encryptAES(data.nombres, getCodeSecurity());
        origenDatos = true;
      } else {
        if (data.apellidoMaterno) {
          data.apellidoMaterno = encryptAES(data.apellidoMaterno, getCodeSecurity());
          origenDatos = true;
        } 
        if (data.apellidoPaterno) {
          data.apellidoPaterno = encryptAES(data.apellidoPaterno, getCodeSecurity());
          origenDatos = true;
        }
      }
      if (data.fechaNacimiento) {
        data.fechaNacimiento = encryptAES(data.fechaNacimiento, getCodeSecurity())
        origenDatos = true;
      }
      if (origenDatos && data.atributos) {
        data.atributos = {
          ...data.atributos,
          origenDatos
        }
      }
    }

    const resp = await HTTP_REQUEST.postWitchTrace(
      url.registerLead,
      data,
      "UTILITARIOS",
      API_SEGURIDAD
    );
    const { payload, status } = await resp.response;
    if (payload && status.success) {
      window.idLead = payload.idLead;
      dispatch(sendLead(payload));
      return { status: status.success, idLead: payload.idLead };
    } else {
      dispatch(changeGlobalState(4));
      dispatch(
        changeErrorData({
          error: status.error,
          code: ERROR_CODE_LEAD,
          message: "No se pudo crear el Lead",
        })
      );
      return { status: status.success };
    }
  } catch (error) {
    dispatch(changeGlobalState(4));
    helpers.sendTagError(error, url.registerLead);
  }
};

export const saveLeadData = (payload) => ({
  type: vidaTypes.SAVE_LEAD_DATA,
  data: payload,
});

export const sendToDigitalId = (payload) => async () => {
  try {
    const response = await HTTP_REQUEST.AmplifyApi({
      name: "DIGITAL_ID",
      path: "",
      data: helpers.getBody(
        {
          cliente: payload,
        },
        {
          consumerId: "WEB",
          channelCode: "VENTA",
        }
      ),
    });
  } catch (err) {
    // console.log('err', err);
  }
};

export const createDigitalId = (payload) => async () => {
  try {
    const response = await HTTP_REQUEST.AmplifyApi({
      name: "DIGITAL_ID",
      path: url.createDigitalId,
      data: helpers.getBodySimple(payload),
    });
    if (
      response?.payload.id !== null 
    ) {
      Cookies.set('audience.authstate', true , {
        expires: 1,
        path: '/',
        domain:'.rimac.com',
      })
      Cookies.set('audience.digital_id', response.payload.id, {
        expires: 1,
        path: '/',
        domain:'.rimac.com',
      })
      helpers.setTagDigitalID(response.payload.id)
    }
    return null;
  } catch (err) {
    console.log('err', err);
    helpers.getTagError('CodGenerico', 'Mensaje de error genérico', 'trackError');
  }
};

export const sendRequestToEmision = (request) => async (dispatch) => {
  const bodyRequest = helpers.getBodySimple(request);
  bodyRequest.headers = { 'x-api-key': decryptCredentials(process.env.REACT_APP_API_KEY_CROSS_CANAL) };
  try {
    await HTTP_REQUEST.AmplifyApi({
      name: "CANAL_CROSS",
      path: url.registrarEmision,
      data: bodyRequest,
    });
  } catch(error) {
    dispatch(changeGlobalState(4));
    helpers.sendTagError(error, url.registrarEmision);
  }
};

export const setHasTaxObligations = (data) => ({
  type: vidaTypes.SET_HAS_TAX_OBLIGATIONS,
  data,
});

export const setHasAcceptedExclusions = (data) => ({
  type: vidaTypes.SET_HAS_ACCEPTED_EXCLUSIONS,
  data,
});

export const setSuscriptionCaseId = (data) => ({
  type: vidaTypes.SET_SUSCRIPTION_CASE_ID,
  data,
});

export const setSuscriptionQuestions = (data) => ({
  type: vidaTypes.SET_SUSCRIPTION_QUESTIONS,
  data,
});

export const setSuscriptionAnswers = (data) => ({
  type: vidaTypes.SET_SUSCRIPTION_ANSWERS,
  data,
});

export const setSuscriptionEnabled = (data) => ({
  type: vidaTypes.SET_SUSCRIPTION_ENABLED,
  data,
});
